var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58012 14.42L11.4331 17.756C11.503 17.8816 11.6076 17.9844 11.7343 18.0523C11.861 18.1202 12.0045 18.1502 12.1478 18.1389C12.2911 18.1275 12.4281 18.0752 12.5425 17.9881C12.6569 17.9011 12.7439 17.783 12.7931 17.648L15.9251 9.03598C15.9738 8.90186 15.9833 8.75664 15.9524 8.61734C15.9214 8.47805 15.8514 8.35047 15.7505 8.24958C15.6496 8.14868 15.522 8.07866 15.3828 8.04774C15.2435 8.01681 15.0982 8.02626 14.9641 8.07497L6.35212 11.207C6.21706 11.2562 6.09899 11.3432 6.01197 11.4576C5.92494 11.572 5.87262 11.709 5.86124 11.8523C5.84986 11.9956 5.8799 12.1391 5.94778 12.2658C6.01566 12.3925 6.11852 12.4971 6.24412 12.567L9.58012 14.42Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 12C0.75 14.9837 1.93526 17.8452 4.04505 19.955C6.15483 22.0647 9.01631 23.25 12 23.25C14.9837 23.25 17.8452 22.0647 19.955 19.955C22.0647 17.8452 23.25 14.9837 23.25 12C23.25 9.01631 22.0647 6.15483 19.955 4.04505C17.8452 1.93526 14.9837 0.75 12 0.75C9.01631 0.75 6.15483 1.93526 4.04505 4.04505C1.93526 6.15483 0.75 9.01631 0.75 12Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/Compass.d84627eb36daa19f0d9096dae20dbc25.svg";
export { ForwardRef as ReactComponent };